import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

// A single number is a stat tile, not a one-bar chart. The delta uses an icon
// plus a sign, never colour alone, so the direction survives a colourblind
// reader and a black-and-white print.
const StatTile = ({ icon: Icon, label, value, change, hint, onClick }) => {
  const hasChange = typeof change === 'number' && Number.isFinite(change);
  const Direction = !hasChange || change === 0 ? Minus : change > 0 ? TrendingUp : TrendingDown;
  const tone = !hasChange || change === 0
    ? 'text-muted-foreground'
    : change > 0 ? 'text-emerald-600' : 'text-destructive';

  const Wrapper = onClick ? 'button' : 'div';

  return (
    <Wrapper
      onClick={onClick}
      className={`bg-card rounded-2xl border border-border/40 p-4 shadow-sm text-left w-full transition-colors ${
        onClick ? 'cursor-pointer hover:border-primary/40 border-none' : ''
      }`}
    >
      <div className="flex items-center gap-2 text-muted-foreground text-[11px] font-bold uppercase tracking-wider">
        {Icon && <Icon className="w-3.5 h-3.5" aria-hidden="true" />}
        <span>{label}</span>
      </div>

      <p className="text-2xl font-black text-foreground leading-none mt-2.5">{value}</p>

      <div className="flex items-center gap-1.5 mt-2 min-h-[16px]">
        {hasChange ? (
          <>
            <Direction className={`w-3 h-3 ${tone}`} aria-hidden="true" />
            <span className={`text-[11px] font-bold ${tone}`}>
              {change > 0 ? '+' : ''}{change}%
            </span>
            <span className="text-[11px] text-muted-foreground">vs last period</span>
          </>
        ) : (
          hint && <span className="text-[11px] text-muted-foreground">{hint}</span>
        )}
      </div>
    </Wrapper>
  );
};

export default StatTile;
